import { RiDraggable } from "@remixicon/react";
import React, { ReactNode } from "react";
import { MetricsDashboardGraph } from "../../../__generated__/api";
import { useTheme } from "../../../contexts/Theme";
import Styles from "../Reports.module.scss";

export default function Title({
    graph,
    createMenu,
    size,
    isAdmin,
}: {
    graph: MetricsDashboardGraph;
    createMenu?: (value: MetricsDashboardGraph) => ReactNode;
    size?: "small" | "large";
    isAdmin: boolean | undefined;
}) {
    const theme = useTheme();
    return graph.title ? (
        <div className={Styles["report-header"]}>

            <div className={Styles["report-title-container"]}>
                {isAdmin && (
                    <div className={Styles["report-widget-draggable"]}>
                        <RiDraggable />
                    </div>
                )}
                {size === "small" ? (
                    <small className={theme.isV3 ? Styles["count-title"] : "text-gray-500"}>
                        {graph.title}
                    </small>

                ) : (
                    <strong className={theme.isV3 ? Styles["report-title"] : "mb-2 d-block ms-1 text-light"}>
                        {graph.title}
                    </strong>
                )}

                {createMenu && (
                    <div className={Styles["report-widget-controls"]}>
                        <div className={Styles["report-widget-buttons"]}>
                            {createMenu(graph)}
                        </div>
                    </div>
                )}

            </div>
        </div>

    ) : undefined;
}

Title.defaultProps = {
    createMenu: undefined,
    size: "large",
};
